module.exports = __webpack_public_path__ + "img/pizzaset-765.2a77b978.png";